export default "__VITE_ASSET__ggkipqHx__"